import { render, staticRenderFns } from "./topTitle.vue?vue&type=template&id=77ab0b68&scoped=true&"
import script from "./topTitle.vue?vue&type=script&lang=js&"
export * from "./topTitle.vue?vue&type=script&lang=js&"
import style0 from "./topTitle.vue?vue&type=style&index=0&id=77ab0b68&lang=scss&scoped=true&"
import style1 from "./topTitle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab0b68",
  null
  
)

export default component.exports